import { createContext, useContext } from 'react';

import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';

export type Flags = {
  personalization: boolean;
  agentCityPrefix: string | null | undefined;
  enableReset: boolean;
  showLocalizedUSP: boolean;
  exludeLocalizedUspForMarkets: string[] | null | undefined;
  isSearchProfile: boolean;
  enableExitPopup: boolean;
};

const FlagsContext = createContext<Flags>({} as Flags);

type FlagsProviderProps = {
  flags: Flags;
};

export const FlagsProvider: ReactFCWithChildren<FlagsProviderProps> = ({ flags, children }) => {
  return <FlagsContext.Provider value={flags}>{children}</FlagsContext.Provider>;
};

export const useFlags = (): Flags => {
  const flags = useContext(FlagsContext);

  return flags;
};
